export default class EmailForm {
    recipient!: string;
    sender: string = "dmyalik@gmail.com";
    subject!: string;
    text!: string;
    html!: string;
}